import React, { Component } from 'react';
import FakeData from '.././fake-data';
import { Link } from 'react-router-dom';

import Geosuggest from 'react-geosuggest';

import { CountryDropdown, RegionDropdown } from 'react-country-region-selector';
import GoogleDocsViewer from 'react-google-docs-viewer';

import './Documents.css';
import { Modal, ComboBox, PublicityPicker, PhonePicker, ConfirmModal, ItemPicker, LoadingState, EmptyState } from './Common';

export default class Documents extends Component {
    constructor(props) {
        super(props);
        this.state = {
            typeFilter: "Documents",
            isAdding: false,
            isAddingDoc: false,
            isShowingSuggestions: false,
            docType: null,
            sport: "",
            team: "",
            filter: "",
            filters: [],
            string: "",
            docs: [],
            isLoading: true,
            coach: ""
        }
    }

    componentDidMount() {
        this._isMounted = true;
        this.getDocs()
    }

    componentWillUnmount() {
        this._isMounted = false;
    }

    getDocs = () => {
        const _that = this;
        const { toId, toType, profile, profileType } = this.props;
        if (!this._isMounted) {
            return
        }
        FakeData.post("/getDocuments.php?auth0", {
            user: {
                id: this.props.toType !== "F" ? this.props.profile.id : this.props.toId,
                type: this.props.toType !== "F" ? this.props.profileType : this.props.toType
            },
            userTo: {
                id: profile.id,
                type: profileType
            }
        }, {
                success: ((res) => {
                    if (!_that._isMounted) {
                        return
                    }
                    if (res.error && _that._isMounted) {
                        _that.setState({
                            isLoading: false
                        });
                    } else if (_that._isMounted) {
                        _that.setState({
                            docs: res.data,
                            isLoading: false
                        });
                        setTimeout((() => {
                            _that.getDocs()
                        }), 1000)
                    }
                }),
                error: ((err) => {
                    _that.setState({
                        isLoading: false
                    });
                })
            })
    }

    setTags = (tag) => {
        const { filters } = this.state
        if (!FakeData.inArray(tag, filters)) {
            filters.push(tag)
            if (!this._isMounted) {
                return
            }
            this.setState({ filters });
        } else {
            const _index = filters.indexOf(tag);
            filters.splice(_index, 1)
            if (!this._isMounted) {
                return
            }
            this.setState({ filters });
        }
    }

    getTeams = (docs = []) => {
        const list = [];
        docs.forEach((item, i) => {
            const teams = FakeData.listify(item.teams)
            teams.forEach((_item,_i)=>{
                if (!FakeData.inArray(_item, list)) {
                    list.push(_item);
                }
            })
        })

        return list;
    }

    getCoaches = (docs = []) => {
        const list = [];
        docs.forEach((item, i) => {
            if (!FakeData.inArray(item.owner.name, list)) {
                list.push(item.owner.name);
            }
        })

        return list;
    }

    inTags = (doc = { tags: [] }) => {
        const { filters } = this.state;

        if (filters.length === 0) {
            return true;
        }

        const _tags = [];
        doc.tags.forEach((item, i) => {
            const __tag = item;
            filters.forEach((_item, _i) => {
                if (__tag === _item && !FakeData.inArray(__tag, _tags)) {
                    _tags.push(__tag);
                }
            })
        })

        return _tags.length > 0 ? true : false;
    }

    inSport = (doc = { sport: { name: "" } }) => {
        const { sport } = this.state;

        if (sport === "") {
            return true;
        }

        return sport === doc.sport.name;
    }

    inUser = (doc = { owner: { name: "" } }) => {
        const { filter } = this.state;

        if (filter === "") {
            return true;
        }

        return filter === doc.owner.name;
    }

    inTeam = (doc = { teams: [] }) => {
        const { team } = this.state;

        if (team === "") {
            return true;
        }

        const teams = doc.teams.filter((item,i)=>{
            return team === item.name;
        })

        return teams.length>0?true:false;
    }

    render = () => {
        const { isAdding, isAddingDoc, docType, isShowingSuggestions, typeFilter, sport, team, coach, filter, string, docs, isLoading, filters } = this.state;
        const { toId, toType, profile } = this.props;
        const noticeCount = docs.filter((item, i) => {
            return !item.isRead;
        }).length;

        return (
            <div className={"documents-page training"}>
                <div data-header="">
                    <div data-tabs="">
                        <span className={(typeFilter === "Documents") ? "active" : ""} onClick={() => this.setState({ typeFilter: "Documents" })}>Documents</span>
                    </div>
                    <div data-filters="">
                        <select className="select-box" value={sport} onChange={(e) => {
                            this.setState({ sport: e.target.value });
                        }} style={{ lineHeight: "30px" }}>
                            <option value="">All sports</option>
                            {
                                FakeData.listify(FakeData.getData("yoo").mySport || FakeData.getData("yoo").sportsFollowed).map((item, i) => {
                                    return (
                                        <option key={i} value={item.name}>{item.name}</option>
                                    )
                                })
                            }
                        </select>
                        <select className="select-box" value={team} onChange={(e) => {
                            this.setState({ team: e.target.value });
                        }} style={{ lineHeight: "30px" }}>
                            <option value="">All teams</option>
                            {
                                this.getTeams(docs).map((item, i) => {
                                    return (
                                        <option key={i} value={item.name}>{item.name}</option>
                                    )
                                })
                            }
                        </select>
                        <select className="select-box" value={filter} onChange={(e) => {
                            this.setState({ filter: e.target.value });
                        }} style={{ lineHeight: "30px" }}>
                            <option value="">All coaches</option>
                            {
                                this.getCoaches(docs).map((item, i) => {
                                    return (
                                        <option key={i} value={item}>{item}</option>
                                    )
                                })
                            }
                        </select>
                    </div>
                    <div data-buttons>
                        <div data-button>
                            <span>Add</span>
                            <div>
                                <a className="add" onClick={() => this.setState({ isAddingDoc: true, docType: "docement" })}></a>
                                {isAdding &&
                                    <a onClick={() => this.setState({ isAddingDoc: true, docType: "docement" })} style={{ backgroundImage: "url(images/document_icon_drk.svg)", opacity: "0.5" }}></a>
                                }
                                {isAdding && this.isAdding &&
                                    <a onClick={() => this.setState({ isAddingDoc: true, docType: "media" })} style={{ backgroundImage: "url(images/add_photo_icon_drk.svg)", opacity: "0.5" }}></a>
                                }
                            </div>
                        </div>
                        <div data-button>
                            <span></span>
                            <div>
                                <a className="alert" onClick={() => this.setState({ isShowingSuggestions: true })} data-notices={noticeCount}></a>
                            </div>
                        </div>
                    </div>
                </div>
                <div data-content="">
                    <div data-side="">
                        <div className="category_selector"> Categories</div>
                        <div className="training-tags">
                            {
                                ["General", "Invoice", "News Letter", "Statements", "Announcements", "Schedules"].map((item, i) => {
                                    return (
                                        <div key={item} className="training-tag" onClick={() => this.setTags(item)}>
                                            <input checked={FakeData.inArray(item, filters) ? true : false} id={item + i} name="checkbox" type="checkbox" />
                                            <label>{item}</label>
                                        </div>
                                    )
                                })
                            }
                        </div>
                        <div className="categories_select_btn" style={{ zIndex: 0 }}>Filter documents</div>
                    </div>
                    <div data-main="">
                        {isLoading &&
                            <LoadingState isShown={true} text={"Loading documents"} style={{ width: "100%", height: "30vw" }} />
                        }
                        {!isLoading && docs.length === 0 &&
                            <EmptyState isShown={true} text={"No documents found"} style={{ width: "100%", height: "30vw" }} icon={"insert_drive_file"} />
                        }
                        {!isLoading && docs.length > 0 &&
                            <table className="documents-list table table-hover">
                                <thead className="documents-list-head">
                                    <tr>
                                        <th>Icon</th>
                                        <th>Title</th>
                                        <th>Description</th>
                                        <th>Type</th>
                                        <th>Date</th>
                                        <th>Action</th>
                                    </tr>
                                </thead>
                                <tbody className="documents-list-body">
                                    {
                                        docs.filter((_item, _i) => {
                                            return this.inSport(_item) && this.inTeam(_item) && this.inUser(_item) && this.inTags(_item)
                                        }).map((item, i) => {
                                            return (
                                                <DocumentItem key={i} item={item} {...this.props} />
                                            )
                                        })
                                    }
                                </tbody>
                            </table>
                        }
                    </div>
                </div>
                {(docType !== null && isAddingDoc) &&
                    <AddDocument toId={this.props.toId} toType={this.props.toType} isOpen={isAddingDoc} {...this.props} sessions={[]} files={[]} isMedia={docType === "media" ? true : false} onClose={(args) => {
                        this.setState({ isAddingDoc: false, docType: null });
                    }} {...this.props} />
                }
            </div>
        )
    }
}

class DocumentItem extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isOpen: false
        }
    }

    render = () => {
        const { isOpen } = this.state;
        const { item } = this.props;

        return (
            <tr style={{ fontWeight: item.isRead ? "" : "bold", cursor: "pointer" }}>
                <td>
                    <img src={"images/" + item.file.type + "_icon.svg"} style={{ width: "30px", height: "30px" }} />
                </td>
                <td>{item.title}</td>
                <td>{item.description}</td>
                <td>{item.file.type}</td>
                <td>{FakeData.moment(item.date).calendar()}</td>
                <td>
                    <a onClick={() => {
                        this.setState({ isOpen: true });
                    }}>Open</a>
                    {isOpen &&
                        <ViewDoc doc={item} isOpen={isOpen} onClose={(args) => {
                            this.setState({ isOpen: false });
                        }} />
                    }
                </td>

            </tr>
        )
    }

}

export class ViewDoc extends Component {
    constructor(props) {
        super(props);
        this.state = {}
    }

    componentDidMount() {
        const { doc } = this.props;
        this._isMounted = true;
        this.readDoc()
        var odfelement = document.querySelector(".odf"),
            odfcanvas = new window.odf.OdfCanvas(odfelement);
        //odfcanvas.load(FakeData.URL.replace("server","")+doc.file.url);
    }

    componentWillUnmount() {
        this._isMounted = true;
    }

    readDoc = () => {
        const { doc, noRead } = this.props;
        if (doc.isRead || noRead) {
            return;
        }

        console.log(doc.isRead)
        const _that = this;
        const _arr = FakeData.nullify(doc.youTag).split("^");
        const { toId, toType, profile, profileType } = this.props;
        if (!this._isMounted) {
            return
        }
        FakeData.post("/readDocument.php?auth0", {
            user: {
                id: _arr[0],
                type: _arr[1]
            },
            id: doc.id
        }, {
                success: ((res) => {

                }),

            })
    }

    render = () => {
        const { doc } = this.props;
        return (
            <Modal isOpen={this.props.isOpen} onClose={this.props.onClose}>
                <div className="add-place odf" style={{ width: "50vw", height: "80vh", padding: 0 }}>
                    {this.is && <iframe src={"https://view.officeapps.live.com/op/embed.aspx?src=" + doc.file.url} width={"100%"} height={"100%"} frameBorder="0" allowFullScreen={true}></iframe>}
                    <GoogleDocsViewer width={"50vw"} height={"80vh"} fileUrl={doc.file.url}/>
                </div>
            </Modal>
        )
    }
}

export class AddDocument extends Component {
    constructor(props) {
        super(props);
        this.state = {
            sport: { id: null, name: null },
            doc: {
                id: null,
                user: {
                    id: this.props.toType !== "F" ? this.props.profile.id : this.props.toId,
                    type: this.props.toType !== "F" ? this.props.profileType : this.props.toType
                },
                teams: [],
                owner: FakeData.getData("yoo"),
                commentType: "doc",
                title: "",
                description: "",
                link: "",
                sport: { id: null, name: "" },
                team: { id: null, name: "" },
                tags: [],
                type: "document",
                isFile: true,
                comments: [],
                likes: [],
                isReadable: false,
                shares: [],
                file: { id: null, name: "" },
                players: []
            },
            linkWarning: "Only enter video url from youtube, vimoe, dailymotion and vine",
            source: {
                from: "",
                like: ""
            },
            errors: {
                link: false,
                title: false,
                description: false,
                file: false,
                sport: false,
                team: false,
                tag: false,
                session: false,
                sportToSee: false,
                teamToSee: false,
                players: false
            },
            session: "",
            currentTeam: { id: null, name: "", players: [] },
            isAll: false,
            isAllTeams: false
        }

        this.onFilesPicked = this.onFilesPicked.bind(this);
    }

    onClose = (args) => {
        this.props.onClose(args)
    }

    onUrlFieldChange = (e) => {
        const { sport, doc, errors, source } = this.state
        const val = e.target.value;
        doc.link = val
        this.setState({
            source: this.checkLinkSource(val),
            doc
        });
    }

    checkLinkSource = (val) => {
        var obj = {
            from: "",
            like: ""
        };

        if ((val.indexOf('youtube') != -1)) {
            obj = {
                from: "YouTube",
                like: "https://youtube.com/watch?v=wvZ6nB3cl1w"
            };
        } else if ((val.indexOf('vimeo') != -1)) {
            obj = {
                from: "Vimeo",
                like: "https://vimeo.com/212692070"
            };
        } else if ((val.indexOf('dailymotion') != -1)) {
            obj = {
                from: "Dailymotion",
                like: "http://www.dailymotion.com/video/xwr14q"
            };
        } else if ((val.indexOf('vine') != -1)) {
            obj = {
                from: "Vine",
                like: "https://vine.co/v/Ml16lZVTTxe"
            };
        } else {
            obj = {
                from: "",
                like: ""
            };
        }

        return obj;
    }

    setTags = (tag) => {
        const { sport, doc, errors, source } = this.state
        if (!FakeData.inArray(tag, doc.tags)) {
            doc.tags.push(tag)
            errors.tag = false
            this.setState({ doc, errors });
        } else {
            const _index = doc.tags.indexOf(tag);
            doc.tags.splice(_index, 1)
            errors.tag = doc.tags.length < 1 ? true : false
            this.setState({ doc, errors });
        }
    }

    setPlayers = (tag) => {
        const { sport, doc, errors, source } = this.state
        if (!FakeData.inArray(tag, doc.players)) {
            doc.players.push(tag)
            errors.players = false
            this.setState({ doc, errors });
        } else {
            const _index = doc.players.indexOf(tag);
            doc.players.splice(_index, 1)
            errors.players = doc.players.length < 1 ? true : false
            this.setState({ doc, errors });
        }
    }

    setTeams = (tag) => {
        const { sport, doc, errors, source } = this.state
        const _teams = doc.teams.filter((item, i) => {
            return item.id === tag.id && item.squadId === tag.squadId
        });
        if (_teams.length === 0) {
            doc.teams.push(tag)
            errors.teams = false
            this.setState({ doc, errors });
        } else {
            const __teams = doc.teams.filter((item, i) => {
                return item.id !== tag.id && item.squadId !== tag.squadId
            });
            doc.teams = __teams;
            errors.teams = doc.teams.length < 1 ? true : false
            this.setState({ doc, errors });
        }
    }

    inTeams = (tag) => {
        const { sport, doc, errors, source } = this.state
        const _teams = doc.teams.filter((item, i) => {
            return item.id === tag.id && item.squadId === tag.squadId
        });
        if (_teams.length === 0) {
            return false
        } else {
            return true
        }
    }

    addSession = (e) => {
        const { session } = this.state;
        const _that = this;
        if (e.keyCode === 13 || e.which === 13) {
            const dataTo = {
                user: {
                    id: this.props.toId,
                    type: this.props.toType
                },
                name: session,
                timeAgo: new Date(),
                files: [],
                description: ""
            }

            //console.log(dataTo)
            FakeData.post('/createSession.php?auth0', dataTo, {
                success(res) {
                    _that.setState({ session: "" });
                },
                error(err) {

                }
            }, true, "", () => { })
        }
    }

    onFilesPicked = (files) => {
        const _that = this
        const { doc } = this.state;
        const file = files[0]
        let reader = new FileReader()
        reader.onloadend = () => {
            const newFile = {
                file: file,
                progress: 0,
                url: reader.result
            }

            doc.file = newFile;

            _that.setState({
                doc
            });

            this.uploadFile(newFile)
        }
        reader.readAsDataURL(file)
    }

    uploadFile = (file) => {
        var formdata = new FormData();
        const _that = this;
        const { toId, toType } = this.props
        formdata.append("file", file.file);
        formdata.append("location", "");
        formdata.append("albumId", 0);
        formdata.append("tags", "");
        formdata.append("toId", this.props.toId);
        formdata.append("objType", "document");
        var ajax = new XMLHttpRequest();
        ajax.upload.addEventListener("progress", (e) => {
            let percent = Math.round((e.loaded / e.total) * 100);
            _that.state.doc.file.progress = percent;
            _that.state.errors.file = (percent < 95) ? true : false;
            _that.setState({
                doc: _that.state.doc,
                errors: _that.state.errors
            });
        }, false);
        ajax.addEventListener("load", (e) => {
            let data = JSON.parse(e.target.responseText)
            data.oldUrl = file.url
            _that.state.doc.file = data;
            _that.state.errors.file = false;
            _that.setState({
                doc: _that.state.doc,
                errors: _that.state.errors
            });
        }, false);
        ajax.open("POST", FakeData.URL + "/uploadMedia.php?auth0&userType=F&userId=" + FakeData.getData("yoo").id + "&type=" + this.props.toType);
        ajax.send(formdata);
    }

    save = () => {
        const { sport, doc, errors, source, isAll, currentTeam } = this.state
        const { sessions, files, isMedia } = this.props
        if (doc.title === null || doc.title === "") {
            errors.title = true;
            this.setState({ errors });
            return;
        }

        if (doc.isFile && doc.file.id === null) {
            errors.file = true;
            this.setState({ errors });
            return;
        }

        if (!doc.isFile && (doc.link === null || doc.link === "")) {
            errors.link = true;
            this.setState({ errors });
            return;
        }

        if (doc.sport.id === null) {
            errors.sport = true;
            this.setState({ errors });
            return;
        }

        if (doc.team.id === null) {
            errors.team = true;
            this.setState({ errors });
            //return;
        }

        if (doc.description === null || doc.description === "") {
            errors.description = true;
            this.setState({ errors });
            return;
        }

        if (doc.tags.length === 0) {
            errors.tag = true;
            this.setState({ errors });
            return;
        }

        if (isAll) {
            const list = [];
            this.getAllPlayers(doc.teams).forEach((item, i) => {
                list.push(item.userId + "^F");
            });

            doc.players = list;
            errors.players = false;
            this.setState({ errors, doc });
        }

        if (doc.players.length === 0) {
            errors.players = true;
            this.setState({ errors });
            return;
        }

        const list = [];
        doc.teams.forEach((item,i)=>{
            if(!FakeData.inArray(item.id,list)){
                list.push(item.id)
            }
        })

        const _that = this;
        doc['teamTags'] = list.join(",");
        console.log(doc);
        FakeData.post("/addDocument.php?auth0", doc, {
            success(e) {
                _that.onClose(e)
            },
            error(e) {
                FakeData.alert("Could'nt save document!");
            }
        }, true, "", (e) => { });
    }

    getAllPlayers = (teams = []) => {
        const _p = [];
        teams.forEach((item, i) => {
            const parents = FakeData.listify(item.players);
            if (parents.length > 0) {
                parents.forEach((p, _i) => {
                    if (!FakeData.inArray(p, _p)) {
                        //p.teamId = item.id;
                        _p.push(p)
                    }
                })
            }
        })

        return _p;
    }

    render = () => {
        const { sport, doc, errors, source, currentTeam, isAll, isAllTeams } = this.state
        const { sessions, files, profile, profileType } = this.props;
        const teams = this.props.teams ? this.props.teams : FakeData.listify(FakeData.getData("yoo").myTeams);
        return (
            <Modal isOpen={this.props.isOpen} onClose={this.onClose}>
                <div className="add-place" style={{ width: "50vw", maxHeight: "80vh", overflowY: "auto" }}>
                    <h1>Document Upload</h1>
                    <div className="split-input">
                        <div>
                            <div className="input-field" style={{ height: "auto", marginBottom: "5px" }}>
                                <span>Document title</span>
                                <input className={errors.title ? "normal-input error" : "normal-input"} onChange={(e) => {
                                    const va = e.target.value;
                                    doc.title = va;
                                    errors.title = false;
                                    this.setState({ doc, errors });
                                }} />
                            </div>
                            {this.props.isMedia &&
                                <div style={{ lineHeight: "30px" }} onClick={() => {
                                    doc.isFile = (doc.isFile) ? false : true
                                    this.setState({ doc });
                                }}>
                                    <input id="isReadable" checked={(doc.isFile) ? false : true} name="checkbox" type="checkbox" /> <label>Add by link?</label>
                                </div>
                            }
                            {(!this.props.isMedia || doc.isFile) &&
                                <div className="input-field" style={{ height: "auto", marginBottom: "5px" }}>
                                    <span>Upload document</span>
                                    <input type={"file"} accept={this.props.isMedia ? "image/*,video/*" : "application/pdf,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document,application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.ms-powerpointtd>,application/vnd.openxmlformats-officedocument.presentationml.presentation"} onChange={(e) => this.onFilesPicked(e.target.files)} className={errors.file ? "normal-input error" : "normal-input"} />
                                </div>
                            }
                            {!doc.isFile &&
                                <div className="input-field" style={{ height: "auto", marginBottom: "5px" }}>
                                    <span>Only enter <code>video url</code> from <code>youtube</code>, <code>vimeo</code>, <code>dailymotion</code> and <code>vine</code></span>
                                    <input className={(source.from === "" || errors.link) ? "normal-input error" : "normal-input"} onChange={this.onUrlFieldChange.bind(this)} />
                                </div>
                            }
                            {(!doc.isFile && source.from !== "") &&
                                <span style={{ fontSize: "11px", display: "block", borderLeft: "2px solid #333", padding: "5px", background: "#f3f6fb" }}>A link from {source.from} should look like <code>{source.like}</code></span>
                            }
                            <div className="input-field" style={{ height: "auto", marginBottom: "0px" }}>
                                <span>Select a sport</span>
                                <ComboBox holderCss={null} error={errors.sport} boxCss={{ marginRight: "0px" }} btnCss={{ height: "27px" }} placeholder={""} onSelectedItem={(item) => {
                                    doc.sport = item
                                    doc.tags = []
                                    errors.sport = false
                                    this.setState({ sport: item, doc, errors });
                                }} data={FakeData.listify(FakeData.getData("yoo").sportsFollowed)} />
                            </div>
                            {profileType === "Fa" &&
                                <div className="input-field" style={{ height: "auto", marginBottom: "0px" }}>
                                    <span>Select team</span>
                                    <ComboBox holderCss={null} error={errors.team} boxCss={{ marginRight: "0px" }} btnCss={{ height: "27px" }} placeholder={""} onSelectedItem={(item) => {
                                        doc.players = [];
                                        doc.team = item
                                        doc.tags = []
                                        errors.team = false
                                        this.setState({ currentTeam: item, doc, errors });
                                    }} data={teams} />
                                </div>
                            }
                            {profileType === "aF" &&
                                <div className="input-field" style={{ height: "auto", marginBottom: "0px" }}>
                                    <span>Select team</span>
                                    <ComboBox holderCss={null} error={errors.team} boxCss={{ marginRight: "0px" }} btnCss={{ height: "27px" }} placeholder={""} onSelectedItem={(item) => {
                                        doc.players = [];
                                        const _team = profile;
                                        _team.players = item.players;
                                        doc.team = _team
                                        doc.tags = []
                                        errors.team = false
                                        this.setState({ currentTeam: _team, doc, errors });
                                    }} data={teams} />
                                </div>
                            }
                        </div>
                        <div>
                            <div className="input-field" style={{ height: "100%" }}>
                                <span>Document description</span>
                                <textarea style={{ height: "100%", resize: "none" }} className={errors.description ? "error" : ""} onChange={(e) => {
                                    const va = e.target.value;
                                    doc.description = va;
                                    errors.description = false;
                                    this.setState({ doc, errors });
                                }} />
                            </div>
                        </div>
                    </div>
                    <h4>Categories</h4>
                    <div className={errors.tag ? "cat-tags error" : "cat-tags"}>
                        {
                            ["General", "Invoice", "News Letter", "Statements", "Announcements", "Schedules"].map((item, i) => {
                                return (
                                    <div className="cat-tag" key={i}>
                                        <div className="cat-item" onClick={() => this.setTags(item)}>
                                            <input checked={FakeData.inArray(item, doc.tags) ? true : false} id={item + i} name="checkbox" type="checkbox" /> <label>{item}</label>
                                        </div>
                                    </div>
                                )
                            })
                        }
                    </div>
                    <h4>Select teams</h4>
                    <div className={errors.players ? "documents-player-select error" : "documents-player-select"}>
                        <div className={isAllTeams ? "documents-player-select-item active" : "documents-player-select-item"} onClick={() => {
                            errors.teams = false;
                            if (isAllTeams) {
                                doc.teams = teams;
                            }
                            this.setState({ isAllTeams: !isAllTeams, errors, doc });
                        }}>All Teams</div>
                        {!isAllTeams &&
                            teams.map((item, i) => {
                                return (
                                    <div className={this.inTeams(item) ? "documents-player-select-item active" : "documents-player-select-item"} key={i} onClick={() => this.setTeams(item)}>{item.name}</div>
                                )
                            })
                        }
                    </div>

                    {currentTeam.id !== null || doc.teams.length > 0 && <h4>Select players</h4>}
                    {currentTeam.id !== null || doc.teams.length > 0 &&
                        <div className={errors.players ? "documents-player-select error" : "documents-player-select"}>
                            <div className={isAll ? "documents-player-select-item active" : "documents-player-select-item"} onClick={() => {
                                errors.players = false;
                                if (isAll) {
                                    doc.players = [];
                                }
                                this.setState({ isAll: !isAll, errors, doc });
                            }}>All</div>
                            {!isAll &&
                                this.getAllPlayers(doc.teams).map((item, i) => {
                                    return (
                                        <div className={FakeData.inArray(item.userId + "^F", doc.players) ? "documents-player-select-item active" : "documents-player-select-item"} key={i} onClick={() => this.setPlayers(item.userId + "^F")}>{item.name}</div>
                                    )
                                })
                            }
                        </div>
                    }
                    <button onClick={this.save.bind(this)}>Submit Document</button>
                </div>
            </Modal>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/Documents.js